import type { SceneObject } from 'trace-viewer/scene';

export interface CatalogImportDetail {
    sceneObject: SceneObject;
    /** A caller-supplied parent takes precedence over the active editor context. */
    parent?: SceneObject;
    /** The owning host supplies its adoption/undo completion synchronously. */
    completion?: Promise<void>;
}

/** Resolve after the host has adopted the import; false means no host claimed it. */
export async function dispatchCatalogImport(sceneObject: SceneObject, parent?: SceneObject): Promise<boolean> {
    const detail: CatalogImportDetail = { sceneObject, ...(parent ? { parent } : {}) };
    window.dispatchEvent(new CustomEvent('trace-catalog:import', { detail }));
    if (!detail.completion) return false;
    await detail.completion;
    return true;
}

/** Catch legacy failures without replacing the promise awaited by AI callers. */
export function acknowledgeCatalogImport(detail: CatalogImportDetail, completion: Promise<void>): void {
    detail.completion = completion;
    void completion.catch(error => { console.error('[Sandbox] Failed to adopt imported asset:', error); });
}
